import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import moment from 'moment';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const formatDate = (value) =>
  value ? moment(value).format('MMM D, YYYY') : null;

// "Oct 15, 2024" for a single day, "Oct 15 – 16, 2024" / "Oct 15, 2024 – Mar 2,
// 2025" for a range, matching how conference/workshop dates are usually shown.
const formatDateRange = (start, end) => {
  if (!start) return null;
  if (!end || start === end) return formatDate(start);
  const startM = moment(start);
  const endM = moment(end);
  if (startM.isSame(endM, 'month') && startM.isSame(endM, 'year')) {
    return `${startM.format('MMM D')} – ${endM.format('D, YYYY')}`;
  }
  return `${formatDate(start)} – ${formatDate(end)}`;
};

const FlexEventCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const dateLabel = formatDateRange(item.event_start_date, item.event_end_date);

  const titleBlock = (
    <>
      {item.event_type && (
        <h6 className="cards__subtitle">{vocabTitle(item.event_type)}</h6>
      )}
      <h4 className="cards__title">{item.title ? item.title : item.id}</h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback={'/event_default_image.svg'}
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {dateLabel && <p className="cards__info">{dateLabel}</p>}
        {item.event_location && (
          <p className="cards__info">{item.event_location}</p>
        )}
      </div>
    </div>
  );
});

FlexEventCard.displayName = 'FlexEventCard';

FlexEventCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    event_type: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    event_start_date: PropTypes.string,
    event_end_date: PropTypes.string,
    event_location: PropTypes.string,
    image_caption: PropTypes.string,
    image_scales: PropTypes.object,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexEventCard;
